import { prefixer, createApiConsts } from '../../../Helpers/constants'
import moment from 'moment'

const createPrefixedConst = prefixer('TWLIO_CONFIG')
const createPrefixedApiConsts = <ApiName extends string>(apiName: ApiName) => createApiConsts(createPrefixedConst(apiName))

export const SELECT_ACTION = createPrefixedConst('SELECT_ACTION')
export const GET_TENANTS = createPrefixedApiConsts('GET_TENANTS')
export const ADD_ACD_CONFIG = createPrefixedApiConsts('ADD_ACD_CONFIG')
export const GET_ACD_CONFIG = createPrefixedApiConsts('GET_ACD_CONFIG')
export const DELETE_ACD_CONFIG = createPrefixedApiConsts('DELETE_ACD_CONFIG')
export const GET_METADATA = createPrefixedApiConsts('GET_METADATA')
export const SUBMIT_TWILIO_CONFIG = createPrefixedApiConsts('SUBMIT_TWILIO_CONFIG')
export const GET_TWILIO_CONFIG = createPrefixedApiConsts('GET_TWILIO_CONFIG')
export const GET_SERVICE_QUEUES = createPrefixedApiConsts('GET_SERVICE_QUQUES')
export const GET_TIMEZONES = createPrefixedApiConsts('GET_TIMEZONES')
export const TEST_CONFIG = createPrefixedApiConsts('TEST_CONFIG')
export const ADHOC_IMPORT_CALL = createPrefixedApiConsts('ADHOC_IMPORT_CALL')
export const RECOVERY_CALL = createPrefixedApiConsts('RECOVERY_CALL')

export const ACD_SERVER = 'ACD Server'
export const DB_SERVER_TYPE = 'TWILIO'

export const CALL_RECOVERY = 'Call recovery'
export const PENDING_UPLOAD = 'Pending upload'
export const TWILIO_RECORDING_STRING = 'Twilio Recording'
export const TWILIO_RECORDING_INT = 25
export const RECAPTURE_TIME_FORMAT = 'hh:mm A'
export const DEFAULT_RECAPTURE_TIME = moment().hour(2).minute(0)
